import { type GlobalToken, Space, type TooltipProps } from 'antd';
import type { PosDisabledWarningType } from 'pos-client/components/shared/General/PosDisabledWarning.tsx';

export const createTooltipWarningProps = ({
  activeWarningCount,
  activeWarnings,
  token,
  tooltipProps,
}: {
  activeWarningCount: number;
  activeWarnings: PosDisabledWarningType[];
  token: GlobalToken;
  tooltipProps?: Omit<TooltipProps, 'title' | 'open' | 'defaultOpen' | 'fresh'>;
}): TooltipProps => ({
  title:
    activeWarningCount > 0 ? (
      <Space size="small" direction="vertical">
        {activeWarnings.map(({ text, key }, index) => (
          <span key={`warning${key}${index}`}>
            <b>{`${index + 1}. `}</b>
            {text}
          </span>
        ))}
      </Space>
    ) : null,
  fresh: true,
  color: 'white',
  ...tooltipProps,
  styles: {
    ...tooltipProps?.styles,
    body: {
      color: token.colorWarningText,
      paddingTop: token.paddingSM,
      paddingBottom: token.paddingSM,
      paddingLeft: token.paddingMD,
      paddingRight: token.paddingMD,
      ...tooltipProps?.styles?.body,
    },
  },
});
